<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M1.158 5.81A.546.546 0 0 0 1 6.192c0 .305.229.54.533.54a.54.54 0 0 0 .381-.159L6.402 1.99h-.627l4.489 4.582a.56.56 0 0 0 .38.158.526.526 0 0 0 .534-.539.547.547 0 0 0-.159-.38L6.485 1.17A.528.528 0 0 0 6.092 1a.55.55 0 0 0-.399.17L1.158 5.81Z"
      fill="currentColor"
    />
  </svg>
</template>
